import { Injectable } from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';

import * as fromActions from './service-automation-detail.actions'
import * as fromGraphql from './service-automation-detail.graphql'
import {map, switchMap} from "rxjs/operators";
import {Apollo} from "apollo-angular";
import {Store} from "@ngrx/store";
import {AppState} from "../../../reducers";
import {NotificationService} from "../../../../services/notification.service";
import {ResponseCodeService} from "../../../../services/response-code.service";
import {editServiceAutomationDetails} from "./service-automation-detail.actions";


@Injectable()
export class ServiceAutomationDetailEffects {

  createServiceAutomationDetail$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createServiceAutomationDetails),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CREATE_SERVICE_BASIC_AUTOMATION_DETAILS,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(({ data }: any) => {

          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertServiceAutomationDetail({ serviceAutomationDetail: result?.data }));
              this.notificationService.successMessage('Created Successfully ');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  updateServiceAutomationDetail$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.editServiceAutomationDetails),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.UPDATE_SERVICE_BASIC_AUTOMATION_DETAILS,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while updating record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.loadServiceAutomationDetails({ serviceAutomationDetails: [result?.data] }));
              this.notificationService.successMessage('Updated Successfully ');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  deleteServiceAutomationDetail$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.removeServiceAutomationDetails),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.DELETE_SERVICE_BASIC_AUTOMATION_DETAILS,
        variables: {
          detailsUniqueId: action?.detailsUniqueId,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while deleting record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.deleteServiceAutomationDetail({ id: action.id }));
              this.notificationService.successMessage('Deleted Successfully');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  getServiceCategories$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getServiceAutomationDetails),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_SERVICE_BASIC_AUTOMATION_DETAILS,
        fetchPolicy: 'network-only',
        variables: {
          filtering: action.filtering
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching service automation details'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadServiceAutomationDetails({ serviceAutomationDetails: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
